import { extend } from 'underscore';
import rawItemTemplate from './universal-item-template.pug';
import { getActionText } from '@bingads-webui-campaign-legacy/adextension-actionlink/model/language-type-text-mapper';

export const universalItemTemplate = (arg0) => rawItemTemplate(extend({ getActionText }, arg0));
